export const STATUS_INITIAL = 'initial';
export const STATUS_PENDING = 'pending';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';
